import { render, staticRenderFns } from "./releases_sort.vue?vue&type=template&id=1eec9d78"
import script from "./releases_sort.vue?vue&type=script&lang=js"
export * from "./releases_sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports